import LocalizedStrings from "react-localization";

export const strings = new LocalizedStrings({
  en: {
    overview: "OVERVIEW",
    title: "Offline Payments",
    subtitle: "overview",
    filter_org: "Filter by Organisation",
    filter_plan: "Filter by Plan",
    select_plan: "Select Plan...",
    select_status: "Select Status...",
    org_name: "Organisation Name",
    plan: "Plan",
    start_date: "Start Date",
    end_date: "End Date",
    status: "Status",
    active: "Active",
    expired: "Expired",
    previous: "Previous",
    next: "Next",
    amount: "Amount",
    paymentMode: "Payment Mode",
    create_payment: "Create Payment",
    action: "Action",
    cancel: "Cancel",
    save: "Save",
    add_offline_payment: "Add Offline Payment",
    select_org: "Select Organisation",
    select_plan_option: "Select Plan",
    enter_amount: "Enter Amount",
    select_payment_mode: "Select Payment Mode",
    cash: "Cash",
    bank_transfer: "Bank Transfer",
    cheque: "Cheque",
    go_back: "Go Back",
    rut_number: "RUT Number",
    payment_method: "Payment Method",
  },
  es: {
    overview: "OVERVIEW es",
    title: "Suscripciones",
    subtitle: "descripción general",
    filter_org: "Filtrar por Organización",
    filter_plan: "Filtrar por Plan",
    select_plan: "Seleccionar Plan...",
    select_status: "Seleccionar Estado...",
    org_name: "Nombre de la Organización",
    plan: "Plan",
    start_date: "Fecha de Inicio",
    end_date: "Fecha de Término",
    status: "Estado",
    active: "Activo",
    expired: "Expirado",
    previous: "Anterior",
    next: "Siguiente",
    amount: "Monto",
    paymentMode: "Método de Pago",
    create_payment: "Crear Pago",
    action: "Acción",
    cancel: "Cancelar",
    save: "Guardar",
    add_offline_payment: "Agregar Pago Offline",
    select_org: "Seleccionar Organización",
    select_plan_option: "Seleccionar Plan",
    enter_amount: "Ingresar Monto",
    select_payment_mode: "Seleccionar Método de Pago",
    cash: "Efectivo",
    bank_transfer: "Transferencia Bancaria",
    cheque: "Cheque",
    go_back: "Go Back es",
    rut_number: "Número RUT",
    payment_method: "Método de pago",
  }
});
